import { utils } from '@yola/ws-sdk';
import settingTypes from '../constants/setting-types';

const getFieldValuesFromSettings = (settings) => ({
  ...settings,
  [settingTypes.SITE_NAME]: settings.siteName || '',
  [settingTypes.BUSINESS_NAME]: utils.unescapeHTML(settings.businessName || ''),
  [settingTypes.BUSINESS_CATEGORY]: settings.businessCategory,
  [settingTypes.BUSINESS_DESCRIPTION]: settings.businessDescription || '',
  [settingTypes.ADDRESSES]: utils.unescapeHTML(settings.addresses?.toString() || ''),
  [settingTypes.PHONES]: settings.phones?.toString() || '',
  [settingTypes.EMAILS]: settings.emails?.toString() || '',
  [settingTypes.BUSINESS_HOURS]: utils.unescapeHTML(settings.businessHours?.toString() || ''),
});

export default getFieldValuesFromSettings;
